import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FileText, ArrowLeft, ShieldCheck } from "lucide-react";
import { DOC_LIST, fetchDoc } from "../lib/legalContent";
import { NeonCard, SectionTitle, Spinner } from "../components/Neon";

function renderBody(body) {
  const lines = (body || "").split("\n");
  const out = [];
  let para = [];
  const flush = (key) => { if (para.length) { out.push(<p key={`p${key}`} className="text-[var(--text-muted)] leading-relaxed">{para.join(" ")}</p>); para = []; } };
  lines.forEach((ln, i) => {
    if (ln.startsWith("## ")) { flush(i); out.push(<h3 key={`h${i}`} className="font-display uppercase tracking-wide text-xl text-white mt-6">{ln.slice(3)}</h3>); }
    else if (ln.trim().startsWith("- ")) { flush(i); out.push(<li key={`l${i}`} className="text-[var(--text-muted)] ml-5 list-disc">{ln.trim().slice(2)}</li>); }
    else if (ln.trim() === "") { flush(i); }
    else { para.push(ln); }
  });
  flush("end");
  return out;
}

export function LegalHub() {
  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-10">
      <SectionTitle accent="white" sub="Everything you need to know about playing fairly and safely."><FileText className="inline h-7 w-7 mr-2 text-[var(--neon-cyan)]" />Legal &amp; Help Centre</SectionTitle>
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        {DOC_LIST.map((d) => (
          <Link key={d.slug} to={`/legal/${d.slug}`} data-testid={`legal-link-${d.slug}`}>
            <NeonCard variant="flow" innerClassName="p-5 flex items-center justify-between">
              <span className="font-display uppercase tracking-wide text-lg text-white">{d.title}</span>
              <span className="text-[var(--neon-cyan)]">›</span>
            </NeonCard>
          </Link>
        ))}
      </div>
      <div className="mt-6 flex items-center gap-2 text-xs text-[var(--text-muted)]"><ShieldCheck className="h-4 w-4 text-[var(--neon-green)]" /> 18+ only. Please play responsibly. Free postal entry available.</div>
    </div>
  );
}

export function LegalDocPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { setLoading(true); fetchDoc(slug).then(setDoc).finally(() => setLoading(false)); }, [slug]);
  if (loading) return <Spinner className="min-h-[50vh]" />;
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-10">
      <Link to="/legal" className="flex items-center gap-2 text-sm text-[var(--text-muted)] hover:text-white"><ArrowLeft className="h-4 w-4" /> All documents</Link>
      <h1 className="mt-4 font-display uppercase text-4xl text-white glow-white">{doc?.title}</h1>
      <NeonCard variant="soft" className="mt-5" innerClassName="p-6 space-y-2" data-testid="legal-doc-body">
        {renderBody(doc?.body)}
      </NeonCard>
    </div>
  );
}
